import { render } from "./ExtraChargeIndex.vue?vue&type=template&id=1751fd9d"
import script from "./ExtraChargeIndex.vue?vue&type=script&lang=js"
export * from "./ExtraChargeIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__